let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5I4RC")).then(() => parcelRequire('eABwY'));